import { persistNextUrlOnSSO } from "@certa/common/utils/routes";
import { certaGoogleLoginURL } from "@certa/network";

/**
 * Used for re-direction to google login
 */
export const RedirectToCertaLogin = () => {
  persistNextUrlOnSSO();
  window.location.href = certaGoogleLoginURL;
  return null;
};
